import Vue from 'vue'
import Vuex from 'vuex'
// import { stat } from 'fs';
import http from '@/http';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin: false,
    userId: null,
    userName: null,
    companyId: '',
    companyList: null,
    language: '',
    languageList: '',
    messageText: '',
    loadingCount: 0,
    menu: null,
    /**記錄最後一次的選單 */
    currentMenu: [],
    showRight: false,
    currentFunctionName: null,
    currentFunctionId: null,
    // rawMenu: null
  },
  mutations: {
    setUserId: function (state, userId) {
      state.userId = userId;
    },
    setMessageText: function (state, text) {
      state.messageText = text;
      setTimeout(function () {
        state.messageText = "";
      }, 3000);
    },
    clearMessageText: function (state) {
      state.messageText = '';
    },
    startLoad: function (state) {
      state.loadingCount++;
    },
    endLoad: function (state) {
      if (state.loadingCount > 0)
        state.loadingCount--;
    },
    setCompanyId: function (state, companyId) {
      state.companyId = companyId;
    },
    setCompanyList: function (state, companyList) {
      state.companyList = companyList;
    },
    setMenu: function (state, menu) {
      // state.rawMenu = menu;
      state.menu = menu;
    },
    setUserName: function (state, value) {
      state.userName = value;
    },
    initMenu: function (state) {
      // var src = state.menu;
      reset(state.menu);
      function reset(m) {
        var target = m.find(x => x.selected);
        if (target) {
          target.selected = false;
          if (target.childNode && target.childNode.length) {
            reset(target.childNode);
          }
        }
      }

    },

    setShowRight: function (state, value) {
      state.showRight = value;
    },
    setCurrentFunctionName: function (state, value) {
      state.currentFunctionName = value
    },
    setCurrentFunctionId: function (state, value) {
      state.currentFunctionId = value
    },
    loginSuccess: function (state) {
      state.isLogin = true;
    },
    logout: function (state) {
      state.isLogin = false;
    },
    setLanguage: function (state, value) {
      state.language = value;
      // window.localStorage["apexlanguage"] = value;
    },
    setLanguageList: function (state, value) {
      state.languageList = value;
    }
  },
  actions: {
    refreshMenu: function ({ commit, state }) {
      var _this = this;
      commit('startLoad');
      http
        .post("/WebApp/Information/GetMenu", {
          companyId: state.companyId,
          language: state.language
        })
        .then(res => {
          state.menu = res.data;
          commit('endLoad');
        })
        .catch(err => {
          //state.menu = res.data;
          commit('endLoad');
        });
    },
  }
})
